import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  Paper, FormControl, TextField, Button, InputLabel, Select, MenuItem,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';
import {
  callSlotEditValidationSchema, getISTOfUTC, getWeekDays, getWeekDaysDates, getUTCOfIST, getWeekDayDate,
} from '../utils/util';
import Actions from '../actions';
import MultipleStringSelection from './MultipleStringSelection';
import { WEEK_DAYS_MAPPINGS, COUNTRY_CODES } from '../utils/constants';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class CallSlotEditForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: '',
      frequency: '',
      isRepeat: false,
      isActive: true,
      time: '',
      cancelledDates: [],
      callType: '',
      date: '',
      duration: 60,
      moderator: '',
      weekDays: [],
      countries: [],
      isPaid: false,
      isTherapistCall: false,
      therapist: '',
    };
  }

  componentDidMount() {
    this.props.getCallTypes();
    this.props.getModerators();
    this.props.getAllTherapists();
    this.weeekMap = [];
    const { data } = this.props;
    let date;
    let time;
    let dateUTC = new Date(data.dateTime);
    if (dateUTC) {
      dateUTC = getISTOfUTC(dateUTC);
      date = data.dateTime.substring(0, 10);
      time = data.dateTime.substring(11, 16);
    } else {
      const today = new Date();
      date = today.toISOString().substring(0, 10);
      time = today.toISOString().substring(11, 16);
    }
    const cancelledDates = data.cancelledDates && data.cancelledDates.map((cancelledDate) => {
      const cancelledDateUTC = new Date(cancelledDate);
      const cancelledDateTime = getISTOfUTC(cancelledDateUTC);
      return cancelledDateTime;
    });
    const weekDaysDates = data.weekDays && data.weekDays.map((weekDayDate) => { return getISTOfUTC(weekDayDate); });
    const weekDays = getWeekDays(weekDaysDates);
    this.setState({
      url: data.url,
      frequency: data.frequency,
      isRepeat: data.isRepeat,
      isActive: data.isActive,
      time,
      cancelledDates,
      // cancelledDates: cancelledDates.filter((cancelledDate) => { return cancelledDate >= new Date(); }),
      callType: data.callType,
      duration: data.duration,
      date,
      moderator: (data.moderator && data.moderator._id) || '',
      weekDays,
      countries: data.countries || [],
      isPaid: data.isPaid || false,
      isTherapistCall: data.isTherapistCall || false,
      therapist: data.therapist || '',
    });
  }

  setWeekDays = (data) => {
    this.weekDays = data;
    this.weekMap = data.map((day) => {
      return WEEK_DAYS_MAPPINGS[day];
    });
    this.weekMap.sort();
  }

  disableOtherDates = (date) => {
    const today = new Date();
    if (this.weekMap.length === 0) return date <= today;
    return date <= today || !this.weekMap.includes(date.getDay());
  }

  setCancelDates=(date, index) => {
    this.setState((prevState) => {
      const cancelledDates = prevState.cancelledDates;
      cancelledDates[index] = date;
      return { ...prevState, cancelledDates };
    });
  }

  addCancelledDate =() => {
    let dateIST = new Date(`${this.state.date}T${this.state.time}Z`);
    dateIST = dateIST.getTime();
    let dateTime = new Date(dateIST);
    const length = this.state.cancelledDates.length;
    const today = new Date();
    if (dateTime < today) dateTime = today;
    if (length > 0 && this.state.cancelledDates[length - 1] > today) {
      dateTime = this.state.cancelledDates[length - 1];
    }
    let date = this.weekMap.length > 0
      ? new Date(getWeekDayDate(this.weekMap[(length % this.weekMap.length)], dateTime))
      : new Date(dateTime);
    this.setState((prevState) => {
      const cancelledDates = prevState.cancelledDates;
      const lastCancelledDate = new Date(cancelledDates[length - 1]);
      if (cancelledDates.length === 0 || date > lastCancelledDate) cancelledDates.push(date);
      else {
        date = date.setDate(date.getDate() + 7);
        cancelledDates.push(date);
      }
      return { ...prevState, cancelledDates };
    });
  }

  removeCancelledDate =(index) => {
    this.setState((prevState) => {
      const cancelledDates = prevState.cancelledDates;
      cancelledDates.splice(index, 1);
      return cancelledDates;
    });
  }

    formupdated = (e) => {
      e.preventDefault();
      const name = e.target.name;
      const value = e.target.value;
      this.setState((prevState) => {
        if (name === 'callType') {
          const callType = this.props.callTypes && this.props.callTypes.find((obj) => { return (obj._id).toString() === value.toString(); });
          const isTherapistCall = (callType && callType.isTherapistCall) || false;
          return { ...prevState, [name]: value, isTherapistCall };
        }
        return { ...prevState, [name]: value };
      });
    }

    formSubmitted = (e) => {
      e.preventDefault();
      const prevData = this.props.data;
      let dateIST = new Date(`${this.state.date}T${this.state.time}Z`);
      dateIST = dateIST.getTime();
      let dateTime = new Date(dateIST);
      let weekDays = getWeekDaysDates(this.weekDays, dateTime);
      dateTime = getUTCOfIST(dateTime);
      weekDays = weekDays.map((weekDayDate) => { return getUTCOfIST(weekDayDate); });
      const frequency = this.state.isRepeat ? this.state.frequency : '';

      const cancelledDates = this.state.cancelledDates && this.state.cancelledDates.map((cancelledDate) => {
        const cancelledDateUTC = new Date(cancelledDate);
        const cancelledDateTime = getUTCOfIST(cancelledDateUTC);
        return new Date(cancelledDateTime);
      });

      const data = {
        _id: this.props.data._id, dateTime, frequency, weekDays,
      };
      const rawData = this.state;
      delete rawData.weekDays;
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, updatedData] of Object.entries(rawData)) {
        if (prevData[key] !== updatedData) data[key] = updatedData;
      }
      data.cancelledDates = cancelledDates;
      // alert(JSON.stringify(data));
      callSlotEditValidationSchema.validate(data)
        .then(() => {
          return this.props.editCallSlot(data)
            .then(() => {
              alert(`Slot Updated Successfully!! \n Data: ${JSON.stringify(data)}`);
              this.props.cancel();
            });
        })
        .catch((err) => { return alert(err); });
    }

    handleChangeMultiple = (event) => {
      let codes = event.target.value;
      if (codes.includes('All') && this.state.countries.length === Object.values(COUNTRY_CODES).length) {
        codes = [];
      } else if (codes.includes('All')) codes = Object.values(COUNTRY_CODES);
      this.setState((prevState) => {
        return { ...prevState, countries: codes };
      });
    };

    render() {
      return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Paper style={{
            width: '500px', padding: '50px', marginTop: 20, maxHeight: '90vh', overflow: 'auto',
          }}
          >
            <h3 style={{ marginTop: 0 }}>Call Slot Form</h3>
            <form className="form" onSubmit={this.formSubmitted} autoComplete="off">
              <FormControl fullWidth style={{ marginTop: '15px' }}>
                <InputLabel id="simple-select-calltype-label">Call Type</InputLabel>
                <Select
                  labelId="simple-select-calltype-label"
                  id="simple-select-calltype"
                  value={this.state.callType}
                  name="callType"
                  onChange={(e) => { return this.formupdated(e); }}
                  style={{ textAlign: 'left' }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {
                    this.props.callTypes && this.props.callTypes.map((type) => {
                      return (<MenuItem key={type._id} value={type._id}>{type.name}</MenuItem>);
                    })
                }
                </Select>
              </FormControl>
              {
                  this.state.isTherapistCall
                    ? (
                      <>
                        <FormControl fullWidth style={{ marginTop: '15px' }}>
                          <InputLabel id="simple-select-calltype-label"> Select Therapist</InputLabel>
                          <Select
                            labelId="simple-select-calltype-label"
                            id="simple-select-calltype"
                            value={this.state.therapist}
                            name="therapist"
                            onChange={(e) => { return this.formupdated(e); }}
                            style={{ textAlign: 'left' }}
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            {
                              this.props.therapists && this.props.therapists.map((type) => {
                                return (<MenuItem key={type._id} value={type._id}>{type.name}</MenuItem>);
                              })
                            }
                          </Select>
                        </FormControl>
                      </>
                    )
                    : null
                }
              <FormControl fullWidth style={{ marginTop: '15px' }}>
                <TextField id="url" name="url" label="Url" value={this.state.url} onChange={(e) => { this.formupdated(e); }} />
              </FormControl>
              <FormControl fullWidth style={{ marginTop: '15px' }}>
                <InputLabel id="simple-select-active-label">Is Active</InputLabel>
                <Select
                  labelId="simple-select-active-label"
                  id="simple-select-active"
                  value={this.state.isActive}
                  name="isActive"
                  onChange={(e) => { return this.formupdated(e); }}
                  style={{ textAlign: 'left' }}
                >
                  <MenuItem value>
                    Yes
                  </MenuItem>
                  <MenuItem value={false}>
                    No
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <MultipleStringSelection
                  label="Week Days"
                  selectionData={Object.keys(WEEK_DAYS_MAPPINGS)}
                  selectedData={this.state.weekDays}
                  callBack={this.setWeekDays}
                />
              </FormControl>
              <FormControl fullWidth style={{ marginTop: '15px' }}>
                <TextField
                  id="duration"
                  name="duration"
                  type="number"
                  label="Duration"
                  value={this.state.duration}
                  onChange={(e) => { this.formupdated(e); }}
                />
              </FormControl>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '15px' }}>
                <FormControl>
                  <TextField
                    id="date"
                    label="Day Of The Month"
                    name="date"
                    type="date"
                    value={this.state.date}
                    onChange={(e) => { return this.formupdated(e); }}
                  />
                </FormControl>
                <FormControl>
                  <TextField
                    id="time"
                    label="Time"
                    name="time"
                    type="time"
                    value={this.state.time}
                    onChange={(e) => { return this.formupdated(e); }}
                  />
                </FormControl>
              </div>
              <FormControl fullWidth style={{ marginTop: '15px' }}>
                <InputLabel id="simple-select-calltype-label">Moderator</InputLabel>
                <Select
                  labelId="simple-select-calltype-label"
                  id="simple-select-calltype"
                  value={this.state.moderator}
                  name="moderator"
                  onChange={(e) => { return this.formupdated(e); }}
                  style={{ textAlign: 'left' }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {
                      this.props.moderators && this.props.moderators.map((type) => {
                        return (<MenuItem key={type._id} value={type._id}>{type.name}</MenuItem>);
                      })
                    }
                </Select>
              </FormControl>
              <FormControl fullWidth style={{ marginTop: '15px' }}>
                <InputLabel id="demo-mutiple-checkbox-label">Select Countries</InputLabel>
                <Select
                  labelId="demo-mutiple-checkbox-label"
                  id="demo-mutiple-checkbox"
                  multiple
                  value={this.state.countries}
                  onChange={this.handleChangeMultiple}
                  input={<Input />}
                  renderValue={(selected) => { return selected.join(', '); }}
                  MenuProps={MenuProps}
                >
                  <MenuItem value="All">
                    <Checkbox checked={this.state.countries.length === Object.values(COUNTRY_CODES).length} />
                    <ListItemText primary="All" />
                  </MenuItem>
                  {Object.values(COUNTRY_CODES).map((name, index) => {
                    return (
                      <MenuItem key={name} value={name}>
                        <Checkbox checked={this.state.countries.indexOf(name) > -1} />
                        <ListItemText primary={`${Object.keys(COUNTRY_CODES)[index]} (${name})`} />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <FormControl fullWidth style={{ marginTop: '15px' }}>
                <InputLabel id="simple-select-active-label">Is Paid</InputLabel>
                <Select
                  labelId="simple-select-active-label"
                  id="simple-select-active"
                  value={this.state.isPaid}
                  name="isPaid"
                  onChange={(e) => { return this.formupdated(e); }}
                  style={{ textAlign: 'left' }}
                >
                  <MenuItem value>
                    Yes
                  </MenuItem>
                  <MenuItem value={false}>
                    No
                  </MenuItem>
                </Select>
              </FormControl>
              {/* {this.state.isRepeat
                ? (
                  <>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <p>Cancelled Dates:</p>
                      <AddCircleOutlineIcon onClick={this.addCancelledDate} />
                    </div>
                    <Paper style={{ maxHeight: 100, overflow: 'auto' }}>
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {this.state.cancelledDates.map((cancelledDate, index) => {
                          const idx = `cancelled${index}`;
                          return (
                            <div key={idx} style={{ display: 'flex', justifyContent: 'space-between' }}>
                              <KeyboardDatePicker
                                key={idx}
                                label={`Cancelled Date ${index}`}
                                variant="inline"
                                name="cancelled Date"
                                style={{ width: 150, margin: 5 }}
                                format="MM/dd/yyyy"
                                value={cancelledDate}
                                onChange={(e) => { this.dateChanged(index, e); }}
                                disablePast
                                shouldDisableDate={this.customDisableDate}
                              />
                              <IconButton
                                onClick={() => {
                                  this.deleteCancelledDate(index);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </div>
                          );
                        })}
                      </div>
                    </Paper>
                  </>
                ) : null} */}
              <div style={{ marginTop: '15px' }}>
                {this.state.cancelledDates.map((cancelledDate, index) => {
                  const key = `Cancelled Date ${index}`;
                  const today = new Date();
                  return (
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '15px' }} key={key}>
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        label={`Cancelled Date ${index}`}
                        value={this.state.cancelledDates[index]}
                        disabled={cancelledDate < today}
                        onChange={(Date) => { return this.setCancelDates(Date, index); }}
                        shouldDisableDate={this.disableOtherDates}
                        InputAdornmentProps={{ position: 'end' }}
                      />
                      <IconButton aria-label="delete" onClick={() => { return this.removeCancelledDate(index); }}>
                        <DeleteIcon fontSize="inherit" />
                      </IconButton>
                    </div>
                  );
                })}
                <Button color="primary" onClick={this.addCancelledDate}>Add Cancelled Date</Button>
              </div>
              <br />
              <FormControl>
                <div style={{
                  width: 400, display: 'flex', justifyContent: 'space-between', marginTop: 20,
                }}
                >
                  <Button variant="contained" color="secondary" onClick={() => { return this.props.cancel(); }}>Cancel</Button>
                  <Button variant="contained" type="submit" color="primary">Confirm</Button>
                </div>
              </FormControl>
            </form>
          </Paper>
        </MuiPickersUtilsProvider>
      );
    }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    callTypes: state.callTypes.data,
    moderators: state.moderator.data,
    therapists: state.therapist.therapists,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CallSlotEditForm));
